import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeDisplayStatus from "./chargeDisplayStatus";
import ChargeOrderPaymentDisplayType from "./chargeOrderPaymentDisplayType";
import ChargeOrderStatus from "./chargeOrderStatus";
import SourceType from "./sourceType";
import VehicleRegisterSynchronizationStatus from "./vehicleRegisterSynchronizationStatus";
import VehicleRegisterVehicleIdentificationResponse from "./vehicleRegisterVehicleIdentificationResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class VehicleRegistrationChangeChargeResponse {
  @observable
  chargeId: string;

  /**
   * License plate for vehicle.
   */
  @observable
  licensePlate!: string;

  /**
   * CountryId for vehicle.
   */
  @observable
  countryId!: string;

  @observable
  vehicleRegisterSynchronizationStatus!: VehicleRegisterSynchronizationStatus;

  @observable
  @Type(() => VehicleRegisterVehicleIdentificationResponse)
  vehicleRegisterVehicle?: VehicleRegisterVehicleIdentificationResponse;

  /**
   * PriceListItem Id.
   */
  @observable
  priceListItemId!: string;

  @observable
  _fuelTypeId: string;

  @observable
  _chargeTypeId!: string;

  /**
   * Beginning date of charge validity (first second)
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * End date of charge validity (last second)
   */
  @observable
  @Type(() => Date)
  validUntil!: Date;

  /**
   * Order identifier (variable symbol).
   */
  @observable
  orderIdent!: number;

  @observable
  sourceType!: SourceType;

  @observable
  chargeOrderPaymentDisplayType?: ChargeOrderPaymentDisplayType;

  @observable
  chargeOrderStatus!: ChargeOrderStatus;

  @observable
  chargeDisplayStatus!: ChargeDisplayStatus;

  /**
   * Confirmation e-mail address.
   */
  @observable
  emailAddress?: string;
}
